module.exports = __webpack_public_path__ + "img/IV-00871_92-a.e84e0677.jpg";